const promiseAllSequential = (
    functions: ((() => Promise<any>) | undefined)[]
) =>
    functions.reduce(
        (promise, func) =>
            promise.then(result => {
                const next = func ? func() : Promise.resolve();
                return next.then(Array.prototype.concat.bind(result));
            }),
        Promise.resolve([] as any[])
    );

export default promiseAllSequential;
